import React from "react";
import { Form, Select } from "antd";
import { makeFieldOptions } from "src/common/makeFieldOptions";
import { ZAttribute } from "src/types/ZAttribute";
import { ZUid } from "src/types/zUid";
import { EdObject } from "../EdObject";
import { EdReqAttributes } from "./EdRequiredAttributes";

interface PropsRequiredAttributes {
  stateId: ZUid;
  attrList?: ZAttribute[];
}

const root: keyof EdObject = "requiredAttrsMap";

const fKey = (key: keyof EdReqAttributes) => key;

export const RequiredAttributes: React.FC<PropsRequiredAttributes> = ({
  stateId,
  attrList,
}) => (
  <Form.Item name={[root, stateId, fKey("attributeIds")]} label="Атрибуты">
    <Select
      options={makeFieldOptions(attrList ?? [])}
      showSearch
      optionFilterProp="filterProp"
      allowClear
      placeholder="Выбрать"
      mode="multiple"
    />
  </Form.Item>
);
